export default function() {
    document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"])').forEach((link) => {
        link.addEventListener('click', function(event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
                location.hostname === this.hostname
            ) {
                const hash = this.hash;
                const target = document.querySelector(hash) || document.querySelector(`[name="${hash.slice(1)}"]`);

                if (target) {
                    event.preventDefault();

                    const top = target.getBoundingClientRect().top + window.scrollY - 150;
                    window.scrollTo({ top, behavior: 'smooth' });

                    if (document.activeElement !== target) {
                        target.setAttribute('tabindex', '-1');
                    }
                }
            }
        });
    });

    const stickyThreshold = 62; // number of pixels before modifying styles
    const nav = document.querySelector('#nav-sticky');

    window.addEventListener('scroll', () => {
        if (!nav) return;
        if (window.scrollY > stickyThreshold) {
            nav.classList.add('sticky');
        } else {
            nav.classList.remove('sticky');
        }
    });
}
